export default {
      id: "insights-project-icon-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "icons.svg#insights-project-icon",
      toString: function () {
        return this.url;
      }
    }